<template>
    <div class="container dirr" style="display: block; padding-top:50px; max-width: 1261px ;" v-if="$i18n.locale === 'ar'">
        <div class="articles-slider-wrapper">
            <v-btn icon class="slider-arrow slider-arrow-left" @click="scrollLeft">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            
            <div class="articles-slider-container" ref="sliderContainer">
                <template v-for="slide in visibleSlides">
                    <!-- Slide 1: Picture Reports -->
                    <div class="article-slide" v-if="slide.type === 'picture_reports'" :key="slide.type">
                        <router-link :to="'/new/photo?lang=ar'" style="text-decoration: none;color: #00112C;" >
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat"  :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/info.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t("Picture_Reports") }}</div>
                                </div>
                            </div>
                        </router-link>
                        
                        <v-card class="my-6 pa-2 ma-2 inf">
                            <template v-for="(card, cardIndex) in cardd">
                                <div class="video_wrapper" v-if="card.video_file" :key="'video-' + cardIndex">
                                    <router-link :to="'/new/photo?lang=ar'">
                                        <video @mouseenter="playVideo" @mouseleave="pauseVideo" @touchstart="playVideo" @touchend="pauseVideo" muted :poster="'https://alkafeel.net/news/images/main/370/' + card.image" :src="'https://alkafeel.net/news/images/infograph/'+card.video_file" class="image-hover-scale full-height-img video-container"></video>
                                    </router-link>
                                    <button v-if="!isPlaying" class="play-btn" @click="togglePlay">
                                        <span class="play-icon">{{ isPlaying ? '❚❚' : '▶' }}</span>
                                    </button>
                                </div>
                                
                                <v-carousel v-else :cycle="true" interval="3000" :show-arrows="false" :key="'carousel-' + cardIndex">
                                    <v-carousel-item v-for="(image, i) in [card.image, ...card.images]" :key="i">
                                        <router-link :to="'/new/photo?lang=ar'" class="item">
                                            <img :src="image.includes('http') ? image : 'https://alkafeel.net/news/images/main/370/' + image" class="image-hover-scale full-height-img">
                                        </router-link>
                                    </v-carousel-item>
                                </v-carousel>
                            </template>
                        </v-card>
                    </div>

                    <!-- Slide 2: Newspaper Stories -->
                    <div class="article-slide" v-if="slide.type === 'newspaper_stories'" :key="slide.type">
                        <a :href="'https://newspaperstories.alkafeel.net'" target="_blank" style="text-decoration: none;color: #00112C;">
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/open-book 1.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">قصص صحفية</div>
                                </div>
                            </div>
                        </a>

                        <v-card height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                            <v-img height="250" :src="'https://newspaperstories.alkafeel.net/uploads/article/thumb/'+storenews.image"></v-img>
                            <v-card-title class="ctitle">{{ storenews.title | truncate(35)}}</v-card-title>
                            <v-card-text class="ctext" v-html="$options.filters.subStrArtTitlesSec(storenews.description)"></v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <div class="mr-auto cfooter">
                                    <a :href="'https://newspaperstories.alkafeel.net/content/show/'+storenews.id" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</a>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </div>

                    <!-- Slide 3: Stories -->
                    <template v-if="slide.type === 'stories'">
                        <div class="article-slide" v-for="(d, i) in c.slice(0,1)" :key="'stories-'+i">
                            <router-link :to="'/new/'+cats[i].url+'?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;">
                                <div class="ma-4">
                                    <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                        <div class="art_cat_icon">
                                            <img src="/assets/img/open-book 1.png">
                                        </div>
                                        <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ cats[i].title }}</div>
                                    </div>
                                </div>
                            </router-link>

                            <v-skeleton-loader v-if="isLoading" class="border" max-width="800" type="image, article"></v-skeleton-loader>
                            
                            <v-card v-if="res[d]" height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                                <v-img height="250" :src="'https://alkafeel.net/news/mcroped96/625/'+res[d].image"></v-img>
                                <v-card-title class="ctitle">{{ res[d].title | truncate(150)}}</v-card-title>
                                <v-card-text class="ctext" v-html="filterBBCode(res[d].text)"></v-card-text>
                                <v-divider class="mx-4"></v-divider>
                                <v-card-actions>
                                    <div class="mr-auto cfooter">
                                        <router-link :to="'/new/stories_inner/'+res[d].id+'?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</router-link>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </div>
                    </template>

                    <!-- Slide 4: Articles -->
                    <div class="article-slide" v-if="slide.type === 'articles'" :key="slide.type">
                        <router-link :to="'/new/article?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;">
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/open-book 1.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">مقالات</div>
                                </div>
                            </div>
                        </router-link>

                        <v-card v-if="articleNews.id" height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                            <v-img height="250" :src="'https://alkafeel.net/news/mcroped96/625/'+articleNews.image"></v-img>
                            <v-card-title class="ctitle">{{ articleNews.title | truncate(35)}}</v-card-title>
                            <v-card-text class="ctext" v-html="$options.filters.subStrArtTitlesSec(filterBBCode(articleNews.text || ''))"></v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <div class="mr-auto cfooter">
                                    <router-link :to="'/new/'+articleNews.id+'?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</router-link>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </div>

                    <!-- Slide 5: Interviews -->
                    <div class="article-slide" v-if="slide.type === 'interviews'" :key="slide.type">
                        <router-link :to="'/new/interviews?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;">
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/open-book 1.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">المقابلات الخاصة</div>
                                </div>
                            </div>
                        </router-link>

                        <v-card v-if="interviewNews.id" height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                            <v-img height="250" :src="'https://alkafeel.net/news/mcroped96/625/'+interviewNews.image"></v-img>
                            <v-card-title class="ctitle">{{ interviewNews.title | truncate(35)}}</v-card-title>
                            <v-card-text class="ctext" v-html="$options.filters.subStrArtTitlesSec(filterBBCode(interviewNews.text || ''))"></v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <div class="mr-auto cfooter">
                                    <router-link :to="'/new/'+interviewNews.id+'?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</router-link>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </div>


                    <!-- Slide 5.5: Files -->
                    <div class="article-slide" v-if="slide.type === 'files'" :key="slide.type">
                        <router-link :to="'/new/files?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;">
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/open-book 1.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''"> ملفات خبرية </div>
                                </div>
                            </div>
                        </router-link>

                        <v-card v-if="fileNews.id" height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                            <v-img height="250" :src="'https://alkafeel.net/news/mcroped96/625/'+fileNews.image"></v-img>
                            <v-card-title class="ctitle">{{ fileNews.title | truncate(35)}}</v-card-title>
                            <v-card-text class="ctext" v-html="$options.filters.subStrArtTitlesSec(filterBBCode(fileNews.text || ''))"></v-card-text>   
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <div class="mr-auto cfooter">
                                    <router-link :to="'/new/'+fileNews.id+'?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</router-link>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </div>
                    

                    <!-- Slide 6: Reports -->
                    <div class="article-slide" v-if="slide.type === 'reports'" :key="slide.type">
                        <router-link :to="'/new/reports?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;">
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/open-book 1.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">تقارير خبرية</div>
                                </div>
                            </div>
                        </router-link>

                        <v-card v-if="reportNews.id" height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                            <v-img height="250" :src="'https://alkafeel.net/news/mcroped96/625/'+reportNews.image"></v-img>
                            <v-card-title class="ctitle">{{ reportNews.title | truncate(35)}}</v-card-title>
                            <v-card-text class="ctext" v-html="$options.filters.subStrArtTitlesSec(filterBBCode(reportNews.text || ''))"></v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <div class="mr-auto cfooter">
                                    <router-link :to="'/new/'+reportNews.id+'?lang='+$i18n.locale" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</router-link>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </div>

                    <!-- Slide 7: Adeb News -->
                    <div class="article-slide" v-if="slide.type === 'adeb_news'" :key="slide.type">
                        <a :href="'https://literaryculturalhorizons.alkafeel.net/'" target="_blank" style="text-decoration: none;color: #00112C;">
                            <div class="ma-4">
                                <div class="fill-heigh articles_cat" :style="$vuetify.theme.dark ? 'background: #474747' : 'background: #F5F5F5'">
                                    <div class="art_cat_icon">
                                        <img src="/assets/img/open-book 1.png">
                                    </div>
                                    <div class="art_cat_title" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">آفاق أدبية وثقافية </div>
                                </div>
                            </div>
                        </a>

                        <v-card height="518px" :loading="loading" class="my-6 pa-2 ma-2">
                            <v-img height="250" :src="'https://literaryculturalhorizons.alkafeel.net/uploads/article/thumb/'+adebnews.image"></v-img>
                            <v-card-title class="ctitle">{{ adebnews.title }}</v-card-title>
                            <v-card-text class="ctext" v-html="adebnews.description"></v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <div class="mr-auto cfooter">
                                    <a :href="'https://literaryculturalhorizons.alkafeel.net/content/'+adebnews.id" style="text-decoration: none;color: #00112C;" :style="$vuetify.theme.dark ? 'color: #FFF' : ''">{{ $t('more') }}</a>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </div>
                </template>
            </div>
            
            <v-btn icon class="slider-arrow slider-arrow-right" @click="scrollRight">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>
    </div>
</template>



<script>

// {title:this.$t("articles"), url:'article'},  'art',
// {title:this.$t("Picture_Reports"), url:'photo'},  'inf', 
export default {
    name: 'carrousel',
    data() {
        return {
            c:['adeb', 'rep'],
            res:[],
            cards: [],
            storenews:'',
            adebnews:'',
            articleNews: {},
            interviewNews: {},
            fileNews: {},
            reportNews: {},
            // cats:[{title:this.$t("adeb"), url:'literature'}, {title:this.$t("news_reports"), url:'reports'}],
            cats:[{title:'قصص مصورة', url:'stories'}],

            isPlaying: false,
            isLoading: true,
            cardd: [],
            story: [],
            // Slides configuration
            slidesControl: [
                { type: 'picture_reports', visible: true, order: 1 },
                { type: 'newspaper_stories', visible: true, order: 2 },
                { type: 'stories', visible: true, order: 3 },
                { type: 'articles', visible: true, order: 4 },
                { type: 'interviews', visible: true, order: 5 },
                { type: 'files', visible: true, order: 5.5 },
                { type: 'reports', visible: true, order: 6 },
                { type: 'adeb_news', visible: true, order: 7 },
            ],
            randomizeSlides: true,
            isMobile: false,
            mobileSlidesLimit: 4,
        }
    },

    computed: {
        swiper() {return this.$refs.mySwiper.$swiper},
        visibleSlides() {
            const sorted = this.slidesControl
                .filter(s => s.visible)
                .sort((a, b) => a.order - b.order);

            if (!this.isMobile) return sorted;

            // On mobile, pin picture reports as the first card; slides are
            // shuffled on mount, so the remaining cards are a random subset.
            const pinned = sorted.filter(s => s.type === 'picture_reports');
            const others = sorted.filter(s => s.type !== 'picture_reports');
            return [...pinned, ...others].slice(0, this.mobileSlidesLimit);
        },
    },
    mounted() {
        if (this.randomizeSlides) {
            this.shuffleSlides();
        }
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    created () {
        this.ini()
        this.grtpicNews()
        this.getstory()
        this.grtstorenews()
        this.get_adeb_news()
        this.getArticleNews()
        this.getInterviewNews()
        this.getFileNews()
        this.getReportNews()
    },
    filters: {
        truncate(value, limit) {
            if (!value) return '';
            if (value.length <= limit) return value;
            return value.substring(0, limit) + '...';
        },
        subStrArtTitlesSec(value) {
            if (!value) return '';

            // Remove HTML tags
            let text = value.replace(/<[^>]+>/g, ' ');

            // Normalize spaces (convert multiple spaces & newlines to a single space)
            text = text.replace(/\s+/g, ' ').trim();
            return text.substring(0, 200) + ' ... ';
        }
    },
    methods:{
        shuffleSlides() {
            for (let i = this.slidesControl.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                const tempOrder = this.slidesControl[i].order;
                this.slidesControl[i].order = this.slidesControl[j].order;
                this.slidesControl[j].order = tempOrder;
            }
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 600;
        },
        filterBBCode(text) {
            // return text;
            const bbcodeRegex = /\[\/?[^\]\[]+\]/g;
            return text.replace(bbcodeRegex, '');
        },
        ini () {
            this.$axios.get("articles/Getmainart")
            .then(data => {
                this.isLoading = false;
                this.res = data.data;
            })
        },
        grtpicNews () {
            this.$axios.get("articles/GetInfograph/1/0", {
            })
            .then(res => {
                this.cardd = res.data.data;
            })
        },


        getstory () {
            this.$axios.get("articles/GetStories/1", {
            })
            .then(res => {
                this.story = res.data.data;
            })
        },


        grtstorenews () {
            this.$axios.get("https://alkafeel.net/alkafeel_back_test/api/v1/story_competition", {
            })
            .then(res => {
                this.storenews = res.data;
            })
        },

        get_adeb_news () {
            this.$axios.get("https://alkafeel.net/alkafeel_back_test/api/v1/literaryculturalhorizons", {
            })
            .then(res => {
                this.adebnews = res.data;
            })
        },
        getArticleNews () {
            this.$axios.get("articles/Getarticle/1", {
            })
            .then(res => {
                this.articleNews = (res.data.data && res.data.data[0]) ? res.data.data[0] : {};
            })
        },
        getInterviewNews () {
            this.$axios.get("articles/Getinterviewnews/1", {
            })
            .then(res => {
                this.interviewNews = (res.data.data && res.data.data[0]) ? res.data.data[0] : {};
            })
        },

        getFileNews () {
            this.$axios.get("articles/Getfilenews/1", {
            })
            .then(res => {
                this.fileNews = (res.data.data && res.data.data[0]) ? res.data.data[0] : {};
            })
        },

        getReportNews () {
            this.$axios.get("articles/Getreportnews/1", {
            })
            .then(res => {
                this.reportNews = (res.data.data && res.data.data[0]) ? res.data.data[0] : {};
            })
        },
        //https://newspaperstories.alkafeel.net/api/alkafeel_home
        playVideo(event) {
            const video = event.target;
            video.play();
            this.isPlaying = true; // Update state to playing
        },
        pauseVideo(event) {
            const video = event.target;
            video.pause();
            this.isPlaying = false; // Update state to paused
        },
        togglePlay(event) {
            const video = event.target.closest('.video-wrapper').querySelector('video');
            if (video.paused) {
            video.play();
            this.isPlaying = true; // Update state to playing
            } else {
            video.pause();
            this.isPlaying = false; // Update state to paused
            }
        },
        updatePlayIcon(event) {
            const video = event.target;
            this.isPlaying = !video.paused; // Sync state with video's playback state
        },
        scrollLeft() {
            const container = this.$refs.sliderContainer;
            const scrollAmount = container.offsetWidth * 0.4; // Scroll by 40% of container width
            container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        },
        scrollRight() {
            const container = this.$refs.sliderContainer;
            const scrollAmount = container.offsetWidth * 0.4; // Scroll by 40% of container width
            container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        },
    },
}
</script> 
<style>

.full-height-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
}
.video-container {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}



.video_wrapper {
  position: relative;
  display: inline-block;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.play-btn:hover {
  background: rgba(0, 0, 0, 0.9);
}

.play-icon {
  margin-left: 4px;
}





.inf .v-carousel {
    overflow:visible
}
.inf .v-carousel__controls .v-icon {
    font-size: 8px;
}
.inf .v-carousel__controls {
    position: relative;
    background: transparent;
}
.inf .mdi-circle::before {
    content: ""!important;
}
.inf .v-carousel__controls__item.v-btn.v-btn--icon {
    background-color: #000; 
    width: 10px;
    height: 10px;
}
  
.inf .v-carousel__controls__item.v-btn.v-btn--icon.v-btn--active {
    background-color: #cac2c2; 
}

.inf .v-carousel__controls__item.v-btn.v-btn--icon:hover {
    background-color: black; 
    
}

.articles-slider .v-carousel__controls {
    background: transparent;
}

.articles-slider .v-carousel__controls__item.v-btn.v-btn--icon {
    background-color: #B1BD52; 
}
  
.articles-slider .v-carousel__controls__item.v-btn.v-btn--icon.v-btn--active {
    background-color: #545454; 
}

/* Custom 2.5 Slider Styles */
.articles-slider-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    /* padding: 0 60px; */
}

.articles-slider-container {
    display: flex;
    /* gap: 20px; */
    overflow-x: auto;
    scroll-behavior: smooth;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    padding: 10px 0;
}

.articles-slider-container::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

.article-slide {
    flex: 0 0 calc(32% - 5px); /* Each slide takes 30% width */
    min-width: calc(32% - 5px);
    scroll-snap-align: start;
}

.slider-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(177, 189, 82, 0.9) !important;
    color: white !important;
}

.slider-arrow:hover {
    background: rgba(177, 189, 82, 1) !important;
}

.slider-arrow-left {
    left: 10px;
}

.slider-arrow-right {
    right: 10px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .article-slide {
        flex: 0 0 calc(50% - 10px);
        min-width: calc(50% - 10px);
    }
}

@media (max-width: 600px) {
    .article-slide {
        flex: 0 0 100%;
        min-width: 100%;
        margin-bottom: 20px;
    }
    
    .articles-slider-wrapper {
        padding: 0 10px;
    }

    .articles-slider-container {
        flex-direction: column;
        overflow-x: visible;
    }

    .slider-arrow {
        display: none !important;
    }
}
</style>
<style scoped>
    @font-face {
        font-family: 'readex';
        src: url("/assets/fonts/ReadexPro/ReadexPro-Regular.ttf") format("truetype");
    }
    @font-face {
        font-family: 'readex_bold';
        src: url("/assets/fonts/ReadexPro/ReadexPro-Bold.ttf") format("truetype");
    }
    .ctitle {
        font-family: 'readex_bold';
        font-size: 14px;
        word-break:keep-all;
        height: 64px;
    }
    .cfooter a{
        font-family: 'readex';
        font-size: 14px;
    }
    .ctext {
        font-family: 'readex';
        font-size: 13px;
        height: 145px;
    }
    .desc2 {
        box-shadow: 0px 4px 4px 0px #00000014;
        background-color: white;
        border-radius: 8px;
        padding: 15px;
    }
    .sec_discrib {
        font-family: 'readex';
        margin: 0 15px;
    }
    .title2 {
        display:ruby
    }
    .title2 .tl {
        font-family: 'readex_bold';
        font-size: 42px;
        /* color:#000; */
        padding: 5px 15px;
        text-decoration: none;
    }
    .spacer {
        width: 4px;
        height: 30px;
        margin: 0 15px;
        background: #B1BD52;
    }
    .art_cat_icon {
        width: 46px;
        height: 46px;
        background: #545454;
        border-radius: 50%;
        text-align: center;
        display: inline-block;
        margin-left: 15px;
        margin-right: 15px;
        vertical-align: middle;
    }
    .art_cat_title {
        display: inline-block;
        font-size: 16px;
        font-family: 'readex';
    }
    .art_cat_icon img {
        margin-top: 14px;
        width: 20px
    }
    .articles_cat {
        background: #F5F5F5;
        /* width: 100%; */
        height: 87px;
        align-content: center;
        text-align: start;
        padding-inline-start: 20px;
        transition: all 0.1s ease; /* Add smooth transition */
    }
    
    .articles_cat:hover {
        border-bottom: 3px solid #B1BD52; /* Add attractive bottom border on hover */
    }
    .swiper-pagination-bullet-active {
        background: #000!important;
    }
    .pro_img {
        margin: 15% auto 5px;
        width: 56px;
    }
    .pro_cat_text {
        text-decoration: unset;
        font-family: 'readex';
        color: #000;
    }
    .pro_cat {
        min-height: 170px;
        vertical-align: middle;
        text-align: center;
        border: #ddd solid thin;
        box-shadow: 22px 40px 40px 0px #0000000D;
        margin: 10px;
        min-width: 200px;
        background-color: #FFF;
    }
    .swiper {
        width: 100%;
        height: 100%;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .swiper-slide img {
        max-height: 210px;
    }
    .height {
        width: 100%;
        height: 100%;
    }
    .gradiant_img {
        background-image: linear-gradient(to top, #0C0F12 0%, transparent 82px);
    }
    .sw_img_date {
        color: white;
        font-family: 'readex';
        font-size: 14px;
        text-decoration: none;
        position: absolute;
        bottom: 8px;
        left: 15px;
    }
    .sw_img_cat {
        color: black;
        font-family: 'readex';
        font-size: 12px;
        font-weight: 400;
        position: absolute;
        bottom: 6px;
        background: #FFF;
        padding: 5px;
        margin-left: 6px;
        margin-right: 6px;
        border-radius: 3px;

    }
    .sw_img_title {
        color: white;
        font-family: 'readex';
        font-size: 20px;
        font-weight: 400;
        position: absolute;
        bottom: 50px;
        left:0;
        right:0;
        text-align: center;
        text-shadow: 1px 1px 2px #000;
    }
    .sw_item {
        vertical-align: bottom;
        border-radius: 5px;
    }
</style>
